/*
 * Viewport-aware positioning for navigation dropdowns below their trigger buttons.
 * Used by the Account, Inbox and Reviews menus.
 * Keeps menus inside narrow windows and sets their available scrolling height.
 * Example: positionNavigationMenu(trigger, menu, context.window);
 */

export function positionNavigationMenu(button, menu, window) {
  const gutter = 8;
  const gap = 8;
  const rect = button.getBoundingClientRect();
  const containingBlock = menu.offsetParent || menu.parentElement;
  const containingRect = containingBlock.getBoundingClientRect();
  const width = menu.getBoundingClientRect().width;
  const left = Math.max(gutter, Math.min(rect.right - width, window.innerWidth - width - gutter));
  menu.style.left = `${left - containingRect.left}px`;
  menu.style.right = 'auto';
  menu.style.bottom = 'auto';

  if (rect.top + rect.height / 2 > window.innerHeight / 2) {
    menu.style.maxHeight = `${Math.max(0, rect.top - gap - gutter)}px`;
    const height = menu.getBoundingClientRect().height;
    menu.style.top = `${rect.top - gap - height - containingRect.top}px`;
  } else {
    menu.style.top = `${rect.bottom + gap - containingRect.top}px`;
    menu.style.maxHeight = `${Math.max(0, window.innerHeight - rect.bottom - gap - gutter)}px`;
  }
}
